import React, { useState } from "react";
import { Footer, Navbar } from "../components";

const AboutPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: "¿Garantizan resultados?",
      a: "Los resultados dependen de la aplicacion. Ofrecemos contenido probado y rutas claras para ejecutar.",
    },
    {
      q: "¿Que nivel tienen los cursos?",
      a: "Hay niveles basico a avanzado, con enfoque tecnico y aplicado.",
    },
    {
      q: "¿Incluyen soporte para resolver dudas?",
      a: "Si, puedes contactarnos por WhatsApp para dudas y orientacion.",
    },
    {
      q: "¿Necesito un dispositivo especifico para acceder?",
      a: "Solo necesitas un celular, tablet o computadora con internet.",
    },
    {
      q: "¿Puedo descargar el contenido?",
      a: "En varios cursos se incluye material descargable y plantillas.",
    },
    {
      q: "¿Cuando puedo comenzar el curso?",
      a: "El acceso es inmediato luego de la compra.",
    },
    {
      q: "¿Los cursos son en vivo o pregrabados?",
      a: "En su mayoria son pregrabados para que avances a tu ritmo.",
    },
    {
      q: "¿Como funcionan las tutorias en vivo?",
      a: "Si el paquete incluye sesiones en vivo, se coordinan por WhatsApp con fechas y horarios disponibles.",
    },
  ];

  const toggleFaq = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <>
      <Navbar />
      <div className="container my-5 py-4">
        <h1 className="text-center" data-aos="fade-up">Sobre A1 Pro</h1>
        <hr />
        <p className="lead text-center" data-aos="fade-up" data-aos-delay="100">
          A1 Pro es una seccion especial de a1cursosmaster con super descuentos
          y posibilidades de negociacion en paquetes de cursos.
        </p>
        <p className="text-center" data-aos="fade-up" data-aos-delay="200">
          Somos un derivado directo de a1cursosmaster. Seleccionamos cursos con
          alta demanda y los ofrecemos en condiciones preferentes para quienes
          quieren avanzar rapido y ahorrar.
        </p>

        <div className="row mt-4">
          <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay="0">
            <h5>Super descuentos</h5>
            <p>
              Precios especiales y promociones reales que no encuentras en
              otras plataformas.
            </p>
          </div>
          <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay="120">
            <h5>Paquetes a medida</h5>
            <p>
              Podemos armar combos y paquetes segun tu necesidad o equipo de
              trabajo.
            </p>
          </div>
          <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay="240">
            <h5>Respaldo real</h5>
            <p>
              Contenido curado y con respaldo de la experiencia de
              a1cursosmaster.
            </p>
          </div>
        </div>

        <div className="faq-section mt-5" id="faq">
          <h2 className="text-center mb-4" data-aos="fade-up">
            Preguntas frecuentes
          </h2>
          <div className="faq-list">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  className="faq-item"
                  key={item.q}
                  data-aos="fade-up"
                  data-aos-delay={(index % 4) * 80}
                >
                  <button
                    className={`faq-question ${isOpen ? "open" : ""}`}
                    type="button"
                    onClick={() => toggleFaq(index)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${index}`}
                    id={`faq-btn-${index}`}
                  >
                    <span>{item.q}</span>
                    <span className="faq-icon">{isOpen ? "–" : "+"}</span>
                  </button>
                  <div
                    id={`faq-panel-${index}`}
                    className={`faq-panel ${isOpen ? "open" : ""}`}
                    role="region"
                    aria-labelledby={`faq-btn-${index}`}
                  >
                    <div className="faq-panel-inner">
                      <div className="faq-answer">{item.a}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AboutPage;
